import { render, staticRenderFns } from "./content-standard-grid.vue?vue&type=template&id=0e6ff794&scoped=true"
import script from "./content-standard-grid.vue?vue&type=script&lang=js"
export * from "./content-standard-grid.vue?vue&type=script&lang=js"
import style0 from "./content-standard-grid.vue?vue&type=style&index=0&id=0e6ff794&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6ff794",
  null
  
)

export default component.exports